<template>
  <a-modal :visible="showDialog"  :mask="true" :maskClosable="false" title="添加" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="分组名">
       <a-input v-model="groupInfo.real_name" placeholder="分组名" />
     </a-form-item>
     <a-form-item label="标识">
       <a-input v-model="groupInfo.name" placeholder="标识" />
     </a-form-item>
     <a-form-item label="排序">
       <a-input v-model="groupInfo.sort" placeholder="排序" />
     </a-form-item>
     <a-form-item label="父级菜单">
        <a-tree-select
          v-model="groupInfo.parent"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="groupList"
          allow-clear
          placeholder="父级菜单"
          treeNodeFilterProp ="real_name"
          show-search
          tree-default-expand-all
          :replaceFields="{children:'children', title:'real_name', key:'id',value:'id' }"
        >
        </a-tree-select>
     </a-form-item>
   </a-form>
  </a-modal>
</template>
<script>
import {GroupSave} from "../../api/v1/group_api";

export default {
  name: "GroupEditDialog",
  props:['showDialog','userList','groupList'],
  data(){
    return {
      groupInfo:{}
    }
  },
  methods:{
    handleOk(){
      let data = {
        "name":this.groupInfo.name,
        "real_name":this.groupInfo.real_name,
        "sort":this.groupInfo.sort,
        "parent":this.groupInfo.parent,
      }

      GroupSave(data).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.groupInfo = {}
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/GroupAddDialog.vue